import CustomerMeterial from './customer_meterial.vue';

export default CustomerMeterial;
